<template>
  <v-data-table
    :items="items"
    :headers="headers"
    :search="search"
    :mobile-breakpoint="0"
    :items-per-page="$vuetify.breakpoint.xsOnly ? items.length + 1 : 25"
    :hide-default-footer="$vuetify.breakpoint.xsOnly"
    sort-by="nom"
  >
    <template v-slot:item.quantity_received="{ item }">
      <j-decimal-input
        class="no-before"
        v-model="item.quantity_received"
        :suffix="
          item.data && item.data.unite_mesure_inventory
            ? item.data.unite_mesure_inventory
            : item.data
            ? item.data.unite_mesure
            : ''
        "
      ></j-decimal-input>
    </template>
    <template v-slot:item.actions="{ item }">
      <v-row align="center" justify="end" no-gutters>
        <v-btn
          icon
          small
          class="ml-2"
          @click="item.quantity_received = item.quantity_ordered"
        >
          <v-icon small>fa-cart-arrow-down</v-icon>
        </v-btn>
      </v-row>
    </template>
    <template v-slot:top>
      <v-row align="center" justify="end">
        <v-col cols="12" sm="6">
          <v-text-field
            hide-details
            single-line
            clearable
            append-icon="fa-search"
            v-model="search"
          ></v-text-field>
        </v-col>
      </v-row>
    </template> </v-data-table
></template>

<script>
export default {
  name: "DeliverySlipCloserGrid",
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      search: "",
      headers: [
        { value: "nom", text: "Produit", width: 200 },
        { value: "quantity_ordered", text: "Commande" },
        { value: "quantity_received", text: "Reçu", width: 150 },
        { value: "actions", text: "", width: 20 }
      ]
    };
  }
};
</script>

<style></style>
